<template>
  <layout-editor-page
    :title="formTitle"
    :isLoading="isLoading"
    :isVisible="isVisible"
    :isBack="isAvailableToSave"
    :isCancel="!isAvailableToSave"
    @command="setCommand"
  >
    <Form
      :data="data"
      :model="formModel"
      @updateModelItem="handlerUpdateModelItem"
      @change="handleFormData"
      ref="Form"/>
    <template v-slot:footer>
      <form-controls
        class="form-footer"
        :isCreate="!hasCreateNew"
        :isSave="hasCreateNew"
        :isDelete="hasCreateNew"
        :isClipboard="hasCreateNew"
        @command="setCommand"/>
    </template>
  </layout-editor-page>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'

export default {
  name: 'EditorLinks',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    Form: () => import(/* webpackChunkName: 'Links' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  data () {
    return {
      // eslint-disable-next-line
      apiPatch: 'ExternalWebsites/Patch/${data.id}'
    }
  },
  computed: {
    formTitle () {
      return this.formData.title || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      return {
        id: '',
        title: '',
        subTitle: '',
        linkURL: '',
        image: ''
      }
    }
  }
}
</script>
